import { ColumnsEdit } from "types/models/column-table-edit";
import React from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import { convertDateStringToDateTimezone_7Dayjs } from "helper/common";
const { DATE } = FIELD_TYPE;

export const itemsInputField: DataFormField[] = [
  {
    type: DATE,
    label: "Thời gian từ",
    name: "start",
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    disableDate: false,
  },
  {
    type: DATE,
    label: "Thời gian đến",
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    disableDate: false,
    name: "end",
  },
];

export const columnss: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "index",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Mã bệnh nhân",
    dataIndex: "maBenhNhan",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "tenBenhNhan",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Khoa",
    dataIndex: "khoa",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
  },
  {
    title: "Chẩn đoán",
    dataIndex: "chanDoan",
    show: true,
    isResizable: true,
    align: "right",
  },
  {
    title: "Tên xét nghiệm",
    dataIndex: "tenXetNghiem",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
  },
  {
    title: "Thời gian chỉ định",
    dataIndex: "thoiGianChiDinh",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (value, record, index) =>
      convertDateStringToDateTimezone_7Dayjs(value),
  },
  {
    title: "Thời gian lấy mẫu",
    dataIndex: "thoiGianLayMau",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (value, record, index) =>
      convertDateStringToDateTimezone_7Dayjs(value),
  },
  {
    title: "Thời gian trả kết quả",
    dataIndex: "thoiGianTraKetQua",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
    render: (value, record, index) =>
      convertDateStringToDateTimezone_7Dayjs(value),
  },
  {
    title: "Thời gian chờ lấy mẫu",
    dataIndex: "thoiGianChoLayMau",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,
  },
  {
    title: "Thời gian thực hiện XN",
    dataIndex: "thoiGianThucHien",
    show: true,
    isResizable: true,
  },
];
